type FormatQuantityOptions = {
  locale?: string; // default: en-IN
  maximumFractionDigits?: number; // default: 2
  fallback?: string; // shown for null/undefined/invalid values, default: "—"
};

/** Formats a quantity (number or API decimal string like `"3.0000"`) for display, trimming trailing zeros. */
export function formatQuantity(
  value: number | string | null | undefined,
  {
    locale = "en-IN",
    maximumFractionDigits = 2,
    fallback = "—",
  }: FormatQuantityOptions = {},
): string {
  if (value === null || value === undefined || value === "") return fallback;

  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;

  return n.toLocaleString(locale, { maximumFractionDigits });
}
